import React from 'react'

import { ZariContext } from '_zari/context'
import { Table, Button, Row, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as CuentaContableService from 'services/cuentaContable.service'

const EnlaceCierreClase679Cell = ({ row }) => {
  const __zariContext = React.useContext(ZariContext)

  const [enlaceCierreClase679, setEnlaceCierreClase679] = React.useState(row.enlaceCierreClase679 || '')
  const [nombreEnlace, setNombreEnlace] = React.useState(row.nombreEnlace || '')

  const clickClear = React.useCallback(() => {
    setNombreEnlace('')
    setEnlaceCierreClase679('')
  }, [])

  const onChangeSelect2 = React.useCallback(optionData => {
    setEnlaceCierreClase679(optionData.value)
    setNombreEnlace(optionData.label)
  }, [])

  const clickGuardar = React.useCallback(() => {
    __zariContext.loader.open('Actualizando registro')
    CuentaContableService.actualizarEnlaceCierreClase679xId(row._id, { enlaceCierreClase679 })
      .then(() => {
        __zariContext.snack('success', 'Registro actualizado')
      })
      .catch(() => {
        __zariContext.snack('error', 'No se pudo actualizar el registro')
      })
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, row._id, enlaceCierreClase679])

  return (
    <>
      <Table.Cell className='zari-slim-form'>
        <Row>
          {row.flagAnalitica ? (
            <>
              <Col md={8}>
                {nombreEnlace ? (
                  <>
                    <ClearInputGroup id={`${row._id}-clear`} iValue={nombreEnlace} clickClear={clickClear} />
                  </>
                ) : (
                  <>
                    <Select2CuentaContable id={`${row._id}-select2`} onChange={onChangeSelect2} onlyAnalitica />
                  </>
                )}
              </Col>
              <Col md={4}>
                <Button outline color='primary' tiny onClick={clickGuardar}>
                  Guardar
                </Button>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </Table.Cell>
    </>
  )
}

export default React.memo(EnlaceCierreClase679Cell)
